






import { Component, Vue } from 'vue-property-decorator';
import WebstoreApiTokenList from '@/components/WebstoreApiToken/WebstoreApiTokenList.vue';

@Component({
  components: {
    WebstoreApiTokenList,
  },
})
export default class WebstoreApiTokens extends Vue {
}
